import Model from 'flarum/common/Model';
export default class TicketCategory extends Model {
  name = Model.attribute('name');
  slug = Model.attribute('slug');
  description = Model.attribute('description');
  /** Id of the department that answers tickets in this category. */
  departmentId = Model.attribute('departmentId');
  position = Model.attribute('position');
  isActive = Model.attribute('isActive');
  department = Model.hasOne('department');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/TicketCategory', TicketCategory);